import { Component, OnDestroy, Input, TemplateRef, ContentChild } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';


@Component({
	selector: 'btn-cell-renderer',
	template:
		`<em>
			<div class="info-btn">
			<span class="align-btn">
				<i *ngIf="enableEdit" class="fas fa-pencil custom-icon"  (click)="btnClickedHandler($event,'edit')"></i>
			</span>
			<span class="align-btn">
				<i *ngIf="enableDelete" class="fas fa-trash-alt custom-icon" (click)="btnClickedHandler($event,'delete')"></i>
			</span>
			</div>
		</em>`,
		styles: [`
			.align-btn{
				display: flex;
				width: 24px;
			}

			.info-btn{
				display: flex;
				gap: 0.8rem;
				color: #fff;
				cursor: pointer;
			}

			::ng-deep .custom-icon {
				/* background: linear-gradient(#000, rgb(49, 49, 49)); */
				border: 1px solid #676A6E;
				padding: 4px 4px 4px 4px;
				/* color: #fff; */
				cursor: pointer;
				background: transparent linear-gradient(180deg, #ffffff 0%, #e9f0f3 100%) 0% 0% no-repeat padding-box;
				opacity: 1;
				font: normal normal bold 10px;
				color: #676a6e;
			}
		`],
	standalone: false,  // NOSONAR
})
export class BtnCellRenderer implements ICellRendererAngularComp, OnDestroy {



	refresh(_params: ICellRendererParams): boolean {
		return false;
	}

	private params: any;
	pageName;
	enableEdit: boolean = true;
	enableDelete: boolean = true;
	boardPage: boolean = false;

	agInit(params: any): void {
		this.params = params;
		this.pageName = this.params.colDef.field;

		//holidays
		if (this.pageName == 'holidays_action') {  // NOSONAR
			this.enableEdit = false;
		}

		// create contingency

		if (this.pageName == 'create_cont_action') {  // NOSONAR
			this.enableEdit = false;
		}


		//boards

		if (this.params.colDef.field == "board_editdelete") {  // NOSONAR

			this.boardPage = true;

			if (this.params.data.SHOW_EDIT == '0') {  // NOSONAR
				this.enableEdit = false;
			}
			else if (this.params.data.SHOW_EDIT == '1') {  // NOSONAR
				this.enableEdit = true;
			}

			if (this.params.data.SHOW_DELETE == '0') {  // NOSONAR
				this.enableDelete = false;
			}
			else if (this.params.data.SHOW_DELETE == '1') { // NOSONAR
				this.enableDelete = true;
			}

		}





	}

	btnClickedHandler(_event: any, action: string): void {
		const { data, colDef, context } = this.params;
		const parent = context.componentParent;

		this.params.clicked(data.categoryID, action);
		this.pageName = colDef.field;

		switch (this.pageName) {
			case 'category_action':
				action == 'delete'                         // NOSONAR
					? parent.deleteRow(data.categoryID)
					: parent.editRow(data.categoryID);
				break;

			case 'OP_action':
				action == 'delete'    // NOSONAR
					? parent.deleteOPRow(data.opID)
					: parent.editOPRow(data.opID);
				break;

			case 'task_action':
				action == 'delete'  // NOSONAR
					? parent.deleteTaskRow(data.taskID)
					: parent.editTaskRow(data.taskID);
				break;

			case 'subtask_action':
				action == 'delete'  // NOSONAR
					? parent.deleteSubTaskRow(data.taskID)
					: parent.editSubTaskRow(data.taskID);
				break;

			case 'templates_action':
				action == 'delete'  // NOSONAR
					? parent.deleteTemplateRow(data.templatetaskID)
					: parent.editTemplateRow(data.templatetaskID);
				break;

			case 'holidays_action':
				if (action == 'delete') {   // NOSONAR
					parent.deleteHolidaysRow(data.holidayId);
				}
				break;

			case 'create_cont_action':
				parent.deleteContingencyRow(this.params);
				break;

			case 'board_editdelete':
				action == 'delete'  // NOSONAR
					? parent.deleteBoardRow(this.params)
					: parent.editBoardRow(this.params);
				break;
		}
	}


	ngOnDestroy() { // NOSONAR

		// do nothing
	}
}
